var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 714,
    height: 166,
    viewBox: "0 0 714 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 714,
    height: 166
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4831 0H714V166H0L80.4831 0Z",
    fill: "#0F2239"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_642)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -133,
    width: 729,
    height: 485,
    fill: "#9FAAB7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M80.4831 0H714V166H0L80.4831 0Z",
    fill: "#0F2239"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.86af1919ebf13b43a9c6948eda649220.svg";
export { ForwardRef as ReactComponent };